import styled from "styled-components";
export const Pulse = styled.div.attrs(props => ({
  color: props.color || "orange"
}))`
  border-radius: 50%;
  position: absolute;
  height: 40px;
  width: 40px;
  animation: pulse-keyframes 2s infinite;
  z-index: 1;

  @keyframes pulse-keyframes {
    0% {
      transform: scale(0.1);
      opacity: 0.3;
      box-shadow: 0 0 0 0 ${props => props.theme.palette[props.color].primary};
    }

    70% {
      transform: scale(1);
      opacity: 1;
      box-shadow: 0 0 0 15px
        ${props => props.theme.palette[props.color].primary + "00"};
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0
        ${props => props.theme.palette[props.color].primary + "00"};
    }
  }
`;